import React from "react";
import { CouponInput } from "shared";
import { useValidateDiscountCode } from "hooks/discounts";
import { DiscountType } from "types/DiscountType";
import "./CouponPackagePro.scss";

interface CouponPackageProProps {
  onDiscountApplied?: (discount: DiscountType) => void;
}

const CouponPackagePro: React.FC<CouponPackageProProps> = ({
  onDiscountApplied,
}) => {
  const validateDiscountMutation = useValidateDiscountCode();

  const handleCouponSubmit = async (coupon: string) => {
    const result = await validateDiscountMutation.mutateAsync({
      code: coupon,
    });

    console.log(result, "result");
    if (result.success && result.data.amount && onDiscountApplied) {
      console.log("przeszło");
      onDiscountApplied(result.data);
    }
  };

  return (
    <div className="coupon_pacage-pro">
      <CouponInput onSubmit={handleCouponSubmit} />
    </div>
  );
};

export default CouponPackagePro;
